var _path, _ellipse, _ellipse2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _circle, _path31, _path32, _circle2, _path33, _path34, _circle3, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _rect, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _circle4, _circle5, _circle6, _circle7, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOcLookingForAnswers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 961,
    height: 773,
    viewBox: "0 0 961 773",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M459.759 362.81C461.925 362.143 467.659 361.51 473.259 364.31",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 439.759,
    cy: 381.31,
    rx: 7,
    ry: 7.5,
    fill: "#223B41"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 496.759,
    cy: 391.31,
    rx: 7,
    ry: 7.5,
    fill: "#223B41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M422.759 369.31C423.259 366.143 426.359 360.11 434.759 361.31",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M486.759 368.31C490.759 364.81 500.759 359.91 508.759 368.31",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M465.259 376.81C469.925 384.477 476.459 400.91 465.259 405.31L459.759 407.31",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M446.259 422.81C447.425 425.977 451.859 431.21 460.259 426.81",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M285.259 349.31C268.859 403.31 314.425 442.477 339.259 455.31C361.659 441.71 393.592 434.81 407.259 432.81C390.259 418.81 385.092 393.143 383.759 381.31C374.759 384.31 350.759 372.81 361.759 349.31C370.559 330.51 380.092 340.143 383.759 347.31L408.259 358.31C408.259 335.51 423.925 327.81 431.759 326.81C436.559 323.61 441.759 313.143 443.759 308.31C446.159 327.11 470.759 340.81 482.759 345.31C498.359 332.91 510.925 340.143 515.259 345.31L526.259 343.81C547.759 336.477 586.359 311.41 568.759 269.81C551.159 228.21 514.759 235.81 498.759 244.81C443.959 208.41 388.925 261.643 368.259 292.81C347.425 289.143 301.659 295.31 285.259 349.31Z",
    fill: "#223B41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M407.759 358.81L383.759 346.31",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M459.259 357.81C459.259 375.055 447.473 388.31 433.759 388.31C420.045 388.31 408.259 375.055 408.259 357.81C408.259 340.564 420.045 327.31 433.759 327.31C447.473 327.31 459.259 340.564 459.259 357.81Z",
    stroke: "#223B41",
    strokeWidth: 5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M525.259 368.81C525.259 386.055 513.473 399.31 499.759 399.31C486.045 399.31 474.259 386.055 474.259 368.81C474.259 351.564 486.045 338.31 499.759 338.31C513.473 338.31 525.259 351.564 525.259 368.81Z",
    stroke: "#223B41",
    strokeWidth: 5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M526.259 465.195C564.659 434.395 542.759 392.862 526.759 375.695C517.959 417.295 497.592 435.195 488.759 439.195L502.759 446.695L526.259 465.195Z",
    fill: "#223B41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M386.759 357.81C385.926 348.643 375.259 326.81 363.759 347.31C358.759 356.643 355.159 376.61 380.759 381.81",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M378.259 354.31C375.925 356.31 372.459 361.51 377.259 366.31",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M383.259 381.81C382.926 402.143 390.859 432.31 427.259 448.31C463.659 464.31 496.092 435.977 507.759 419.81C514.259 410.803 520.459 396.31 523.259 380.31",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M424.759 448.81V463.31",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M405.759 454.81C412.592 461.31 432.859 473.31 459.259 469.31",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M455.259 696.31L444.259 612.81C486.259 570.01 553.759 576.31 582.259 584.81L603.759 627.31C612.592 642.643 636.959 679.21 663.759 702.81C663.759 707.31 646.559 712.31 577.759 696.31C508.959 680.31 465.759 719.976 452.759 741.81",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M652.259 708.81L645.259 730.31L476.759 752.81C470.259 758.31 454.559 766.01 443.759 752.81C432.959 739.61 275.259 747.31 197.759 752.81",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M466.759 741.81C437.092 712.81 348.759 667.31 232.759 717.31",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M254.259 635.81L232.759 716.81",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M232.759 617.81L197.759 752.81",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M197.759 752.695L232.759 716.695",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M443.759 610.81C429.64 590.33 380.273 555.98 295.759 582.414",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M486.759 736.81C492.592 728.643 511.359 713.11 539.759 716.31",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M604.259 624.81C609.259 600.31 603.959 537.51 542.759 482.31L502.259 446.81L476.759 433.31L471.759 432.31L452.759 436.81L450.759 438.81L444.259 450.81C443.259 453.31 447.559 456.21 454.759 453.81C463.759 450.81 457.259 446.81 473.759 446.81M463.911 447.81C456.911 450.81 446.759 461.61 450.759 468.81C451.259 469.643 452.759 471.21 454.759 470.81C455.635 470.635 457.062 469.11 459.085 467.31M476.759 461.31C468.637 459.686 462.838 463.971 459.085 467.31M459.085 467.31C456.477 472.977 454.359 483.61 466.759 480.81M466.759 480.81C469.592 477.31 477.259 470.81 485.259 472.81M466.759 480.81C465.259 483.977 464.559 490.21 473.759 489.81C485.259 489.31 488.759 472.81 502.259 499.31C513.059 520.51 513.759 562.143 512.759 580.31",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M405.759 434.81C373.259 439.143 295.759 462.91 237.759 533.31C179.759 603.71 260.259 641.977 307.759 652.31C322.259 653.477 350.759 653.41 348.759 643.81M333.759 639.31C339.426 639.31 352.159 640.61 357.759 645.81C360.098 647.681 364.799 649.464 366.051 642.81M345.759 631.31C352.926 631.143 367.059 632.91 366.259 641.31C366.207 641.852 366.137 642.351 366.051 642.81M351.259 622.31C356.587 621.92 366.556 623.172 372.206 629.81M366.051 642.81C374.685 646.41 376.12 640.31 375.759 636.81C375.054 633.99 373.803 631.685 372.206 629.81M338.259 527.31C335.092 529.643 328.359 537.21 326.759 548.81C325.159 560.41 306.759 566.977 297.759 568.81C290.426 570.81 282.159 578.51 307.759 593.31C311.759 595.31 319.759 600.21 333.759 597.81C353.259 594.467 356.159 600.81 373.759 616.81C377.224 619.89 381.764 626.802 372.206 629.81",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M322.759 556.81L309.759 577.81",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75879 635.81L228.259 624.81",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M602.759 623.695L763.979 614.195",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M440.759 43.8099C440.259 39.8099 444.794 28.6091 457.759 31.3099C469.259 33.7058 471.759 46.3099 463.759 53.8099C459.259 58.4965 453.159 66.4099 454.759 74.8099",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M503.759 44.8099C507.359 15.2099 486.259 13.1433 475.259 15.8099C456.059 -7.39008 439.259 6.14325 433.259 15.8099C403.659 12.2099 400.926 33.6433 403.259 44.8099C382.459 61.6099 394.592 79.4766 403.259 86.3099C398.859 115.11 421.759 118.643 433.759 116.81C450.959 139.21 468.592 125.477 475.259 115.81C503.659 119.41 506.092 97.6432 503.759 86.3099C527.359 68.7099 513.592 51.3099 503.759 44.8099Z",
    stroke: "#223B41",
    strokeWidth: 5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 455.376,
    cy: 88.9136,
    r: 4.5,
    transform: "rotate(61.4426 455.376 88.9136)",
    fill: "#223B41"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M645.787 143.515C645.408 140.509 648.847 132.093 658.677 134.122C667.397 135.922 669.293 145.394 663.227 151.03C659.815 154.551 655.189 160.498 656.402 166.81",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M693.857 144.354C696.592 122.022 680.558 120.463 672.199 122.474C657.609 104.971 644.843 115.181 640.283 122.474C617.79 119.758 615.713 135.929 617.486 144.354C601.68 157.028 610.9 170.508 617.486 175.663C614.143 197.392 631.544 200.057 640.663 198.674C653.734 215.574 667.133 205.213 672.199 197.92C693.781 200.636 695.63 184.214 693.857 175.663C711.79 162.385 701.329 149.258 693.857 144.354Z",
    stroke: "#223B41",
    strokeWidth: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 657.256,
    cy: 177.514,
    r: 3.40738,
    transform: "rotate(61.4426 657.256 177.514)",
    fill: "#223B41"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M212.779 172.753C212.508 170.567 214.965 164.446 221.986 165.922C228.215 167.231 229.569 174.12 225.236 178.218C222.799 180.78 219.495 185.104 220.361 189.695",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M247.567 173.606C249.554 157.386 237.908 156.253 231.837 157.715C221.24 145.002 211.967 152.417 208.655 157.715C192.318 155.742 190.81 167.487 192.098 173.606C180.617 182.812 187.314 192.602 192.098 196.347C189.669 212.128 202.308 214.064 208.931 213.06C218.425 225.334 228.157 217.809 231.837 212.512C247.511 214.484 248.855 202.557 247.567 196.347C260.592 186.702 252.994 177.168 247.567 173.606Z",
    stroke: "#223B41",
    strokeWidth: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 220.807,
    cy: 197.967,
    r: 2.47896,
    transform: "rotate(61.4426 220.807 197.967)",
    fill: "#223B41"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M166.259 772.195L228.759 624.695L197.759 752.695L297.259 749.195L347.259 747.695H396.759L422.259 748.695L444.259 753.695L166.259 772.195Z",
    fill: "#223B41",
    fillOpacity: 0.4
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M473.759 642.151C482.592 627.151 512.659 600.651 562.259 614.651",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M483.759 676.332C496.592 657.166 537.459 625.832 598.259 653.832",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M434.759 682.575C408.592 668.575 341.759 646.475 283.759 670.075",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M423.759 635.695C415.092 630.695 393.459 622.195 376.259 628.195",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M672.979 448.195L624.979 450.195",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M673.479 448.195L736.479 453.695",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M736.979 453.695L724.479 513.195",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M724.479 513.195L671.979 522.195",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M671.979 521.695V459.195",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M671.979 459.695L736.479 454.195",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M671.979 459.695L624.979 450.195",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M623.979 450.195L626.979 497.195",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M626.979 497.195L671.979 522.195",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M672.479 448.195V458.695",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 696.069,
    y: 474.366,
    width: 17.513,
    height: 8.72172,
    rx: 4.36086,
    transform: "rotate(-3.53924 696.069 474.366)",
    stroke: "#223B41",
    strokeWidth: 3
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M605.979 380.695C614.979 394.862 639.579 421.695 665.979 415.695L702.979 388.695",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M605.979 380.695L647.979 366.695",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M647.979 366.695C655.813 373.862 677.779 388.195 702.979 388.195",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M629.479 387.695C633.146 386.862 641.579 384.195 645.979 380.195",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M639.979 396.695C642.313 396.195 647.679 394.295 650.479 390.695",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M652.479 403.195C655.313 402.695 662.779 400.395 665.979 393.195",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M671.479 537.195L623.979 498.195L671.479 524.695L726.746 515.195H734.479L671.479 537.195Z",
    fill: "#223B41",
    fillOpacity: 0.3
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M821.044 568.195L796.544 549.195C791.744 545.473 798.877 543.644 803.044 543.195L894.544 531.695C906.044 533.195 931.444 536.995 941.044 540.195C950.644 543.395 947.71 546.528 945.044 547.695C915.044 553.195 852.144 565.095 840.544 568.695C828.944 572.295 822.71 569.862 821.044 568.195Z",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M944.043 541.195C947.543 542.362 958.743 552.895 953.543 577.695C951.543 584.195 946.043 588.195 928.043 588.195H834.543C830.21 588.528 820.243 587.895 815.043 582.695C809.843 577.495 799.21 566.528 794.543 561.695C793.543 560.528 792.543 558.195 796.543 558.195",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M796.543 558.195V549.695",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M796.543 561.195L817.043 577.195C819.543 579.195 824.043 582.695 835.543 582.195C846.846 581.704 907.877 580.528 937.043 581.195C941.383 581.294 947.043 579.195 948.043 569.195C949.338 556.25 947.043 548.195 942.043 548.195",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M797.544 566.695L778.544 568.195C775.877 568.195 770.644 569.495 771.044 574.695C771.444 579.895 771.21 582.862 771.044 583.695C770.544 586.195 773.044 588.195 776.044 590.695L800.044 611.695",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M802.543 587.695L800.043 611.695",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M802.543 587.695L775.543 570.195",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M802.043 588.195L819.043 586.195",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M800.043 611.695L941.043 614.695",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M942.043 587.195L941.043 614.195",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 819.043,
    cy: 601.195,
    r: 3,
    fill: "#223B41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 835.043,
    cy: 627.195,
    r: 3,
    fill: "#223B41"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 926.043,
    cy: 600.195,
    r: 3,
    fill: "#223B41"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 944.043,
    cy: 628.195,
    r: 3,
    fill: "#223B41"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M786.043 613.695L810.543 637.195C814.043 640.695 823.043 641.695 843.043 641.695C861.552 641.695 926.71 639.862 957.043 640.195",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M957.543 614.695L957.043 640.195",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M957.543 614.695L942.043 607.695",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M789.043 602.195C789.21 605.195 788.743 611.595 785.543 613.195",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M816.043 613.195C817.377 614.695 819.043 619.195 817.543 626.195C816.372 631.661 814.543 636.695 810.543 636.195",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M957.543 615.195L939.043 614.695",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M799.043 626.195L777.043 638.695",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M777.043 638.695C773.877 644.862 768.943 662.095 774.543 683.695",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M775.043 683.695L889.543 691.195C896.377 691.362 911.643 690.195 918.043 684.195C924.443 678.195 936.543 665.028 942.043 659.195",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M942.043 659.195L942.043 644.195",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M941.544 643.695L912.544 670.195C911.377 671.528 906.944 673.795 898.544 672.195C890.144 670.595 826.377 654.862 795.544 647.195C789.71 645.862 780.044 646.195 779.544 658.695C778.877 664.362 779.844 675.895 789.044 676.695C798.244 677.495 861.544 680.362 892.044 681.695C900.377 682.195 916.544 683.695 933.544 668.195",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcLookingForAnswers);
export default __webpack_public_path__ + "static/media/oc-looking-for-answers.0b088a733bcb0b01ab3aa7e63169037a.svg";
export { ForwardRef as ReactComponent };